import { TableUIProvider } from "../../contexts/TableUIContext";
import Branches from "./Branches";

export default function BranchesWrapper() {
    return (
        <TableUIProvider>
            <Branches />
        </TableUIProvider>
    );
}
